// eslint-disable-next-line


import React from 'react'

import SimpleTable from '../../shared/SimpleTable/SimpleTable'
import SimplePopUp from '../../shared/SimplePopUp/SimplePopUp'
import SimpleDeletePopUp from '../../shared/SimpleDeletePopUp/SimpleDeletePopUp'
import DivisionsForm from './DivisionsForm'
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined';
import axios from 'axios'
import AlertMessage from "../../shared/Notify/AlertMessage";
import ProgressBar from "../../shared/ProgressBar/ProgressBar";

class Divisions extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      model: 'Division',
      divisions: [],
      branches: [],
      departments: [],
      openPopup: false,
      openDeletePopup: false,
      division: {},
      initialDivisions: {
        id: '',
        branch_department_id: '',
        name: '',
        short_name: '',
        description: ''
      },
      title: '',
      load: false,
      tableHead: ['branch.name', 'department.name', 'Name', 'short_name', 'description'],
      withShow: false,
      withEdit: true,
      maxWidth: 'sm',
      error_messages: '',
      notify: {},
      isOpen: false,
      message: '',
      type: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleDeleteItem = this.handleDeleteItem.bind(this)
    this.handleCreateorUpdateItem = this.handleCreateorUpdateItem.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleOpenDeletePopup = this.handleOpenDeletePopup.bind(this)
    this.handleDeleteClose = this.handleDeleteClose.bind(this)
    this.handleCloseAlert = this.handleCloseAlert.bind(this)
    this.handleAutocomplete = this.handleAutocomplete.bind(this)
  }

  componentDidMount() {
    this.loadDivisions('/v1/divisions')
  }

  loadDivisions(url) {
    if(localStorage.getItem('divisions') !== null){
      this.setState({divisions: JSON.parse(localStorage.getItem('divisions')), load: true})
    }else{
    axios({
      method: 'get',
      url: url,
      headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
    }).then(resp => {
      this.setState({divisions: resp.data})
      localStorage.setItem('divisions',JSON.stringify(resp.data))   
    }).catch(error => console.log(error.response))
  }

  if(localStorage.getItem('branches') !== null){
    this.setState({branches: JSON.parse(localStorage.getItem('branches')), load: true})
  }else{
    axios({
      method: 'get',
      url: '/v1/branches',
      headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
    }).then(resp => {
      this.setState({branches: resp.data})
      localStorage.setItem('branches',JSON.stringify(resp.data))
    }).catch(error => console.log(error.response))
  }

  if(localStorage.getItem('branchDepartments') !== null){
    this.setState({ branchDepartments: JSON.parse(localStorage.getItem('branchDepartments')), load: true })
  } else {
      axios({
        method: 'get',
        url: '/v1/branch_departments',
        headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
      }).then(resp => {
        this.setState({ branchDepartments: resp.data, load: true})
        localStorage.setItem('branchDepartments', JSON.stringify(resp.data))
      }).catch(error => console.log(error.response))
  }  
  }

  handleSubmit() {
    const item = this.state.division
    var method = ''
    var url = ''
    if (item.id === '') {
      method = 'post'
      url = '/v1/divisions/'
    } else {
      method = 'put'
      url = '/v1/divisions/' + item.id
    }

    axios({
      method: method,
      url: url,
      data: (item),
      headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
    }).then(resp => {
      const newData = resp.data
      this.setState({
        divisions: this.state.divisions.filter(division => division.id !== item.id)
      })
      localStorage.setItem('divisions',JSON.stringify([...this.state.divisions, newData]))
      this.setState({divisions: [...this.state.divisions, newData]})
      this.setState({openPopup: false})
      this.setState({
        isOpen: true,
        message: 'Submitted Successfully',
        type: 'success'
      })
    }).catch(error => {
      if (error.response.status === 422) {
        this.setState({error_messages: 'Name ' + error.response.data.errors.name[0]})
      } else {
        this.setState({
          isOpen: true,
          message: error.response.status.toString() + " Unexpected Error Problem Occurred",
          type: 'error'
        })
        this.setState({openPopup: false})
      }
    })
  }

  handleDeleteItem() {
    const DeleteItemId = this.state.division.id
    axios({
      method: 'delete',
      url: '/v1/divisions/' + DeleteItemId,
      headers: {'X-API-ACCESS-TOKEN': localStorage.getItem('api_key')}
    }).then(() => {
      this.setState({
        divisions: this.state.divisions.filter(item => item.id !== DeleteItemId)
      })
      this.setState({openDeletePopup: false})
      this.setState({
        isOpen: true,
        message: 'Deleted Successfully',
        type: 'error'
      })
    }).catch(error => console.log(error.response))
  }

  handleClose() {
    this.setState({openPopup: false})
    this.setState({openDeletePopup: false})
    this.setState({error_messages: ''})
  }

  handleCreateorUpdateItem(item, isAdd, model) {
    var textTitle = ''
    if (isAdd) {
      textTitle = 'Create ' + model
      this.setState({ updateBranchDept: {} })
    } else {
      textTitle = 'Edit ' + model
      this.setState({ 
        updateBranchDept: item
      })
    }
    this.setState({openPopup: true})
    this.setState({division: item})
    this.setState({title: textTitle})
  }

  handleInputChange(e) {
    this.setState({
      division: {
        ...this.state.division,
        [e.target.name]: e.target.value
      }
    })
  }

  handleOpenDeletePopup(item, model) {
    this.setState({model: model})
    this.setState({division: item})
    this.setState({openDeletePopup: true})
  }

  handleDeleteClose() {
    this.setState({openDeletePopup: false})
  }

  handleCloseAlert(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({isOpen: false})
  }

  handleAutocomplete(event, values) {
    if(values) {
      this.setState({
        division: {
            ...this.state.division,
            branch_department_id: values.id
        },
        updateBranchDept: values
      })
    }
  }

  render() {
    return (
      <>
        {
          this.state.load ? (
            <div>
              <SimpleTable
                handleClick={this.handleCreateorUpdateItem}
                initialItem={this.state.initialDivisions}
                items={this.state.divisions}
                model={this.state.model}
                onOpenDeletePopup={this.handleOpenDeletePopup}
                headers={this.state.tableHead}
                withShow={this.state.withShow}
                withEdit={this.state.withEdit}
                icon={<AccountBoxOutlinedIcon fontSize="large"/>}
              />

              <SimplePopUp
                openPopup={this.state.openPopup}
                title={this.state.title}
                handleClose={this.handleClose}
                maxWidth={this.state.maxWidth}
              >
                <DivisionsForm
                  error={this.state.error_messages}
                  item={this.state.division}
                  handleAutocomplete={this.handleAutocomplete}
                  submit={this.handleSubmit}
                  onchange={this.handleInputChange}
                  branchDepartments={this.state.branchDepartments}
                  updateBranchDept={this.state.updateBranchDept}
                  />
                  
              </SimplePopUp>

              <SimpleDeletePopUp
                openDeletePopup={this.state.openDeletePopup}
                item={this.state.division}
                delete={this.handleDeleteItem}
                handleDeleteClose={this.handleClose}
                model={this.state.model}
              />
              <AlertMessage
                notify={this.state.notify}
                handleCloseAlert={this.handleCloseAlert}
                isOpen={this.state.isOpen}
                type={this.state.type}
                message={this.state.message}
              />
            </div>
          ) : (
            <ProgressBar model={this.state.model}/>
          )}
      </>
    )
  }
}

export default Divisions
